(ns manatee.models.differences)

(defn different [token] (assoc token :different? true))

(defn conj-different [script token] (conj script (different token)))

(defn insertion? [{:keys [type] :as _token}] (contains? #{:edit :space-edit :tag} type))

(defn remove-flags
  [script]
  (mapv (fn [token] (dissoc token :different?)) script))

(defn flag-differences
  [{:keys [script-a script-b]}]
  (loop [script-a (remove-flags script-a)
         script-b (remove-flags script-b)
         ret-a []
         ret-b []]
    (let [token-a (first script-a)
          token-b (first script-b)]
      (cond
        (= nil token-a token-b)
        {:script-a ret-a
         :script-b ret-b}

        (= token-a token-b)
        (recur
         (rest script-a)
         (rest script-b)
         (conj ret-a token-a)
         (conj ret-b token-b))

        (insertion? token-a)
        (recur
         (rest script-a)
         script-b
         (conj-different ret-a token-a)
         ret-b)

        (insertion? token-b)
        (recur
         script-a
         (rest script-b)
         ret-a
         (conj-different ret-b token-b))

        :else
        (recur
         (rest script-a)
         (rest script-b)
         (conj-different ret-a token-a)
         (conj-different ret-b token-b))))))
